<template>
  <div class="personal-data">
    <div class="wrapper">
      <div class="title">核對資料</div>
      <div class="wrapList">
        <div
          class="item acea-row row-between-wrapper"
          :class="item.uid === userInfo.uid ? 'on' : ''"
          v-for="(item, index) in switchUserInfo"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <div class="pictrue">
                <img :src="item.avatar" />
              </div>
            </div>
            <div class="text">
              <div class="name line1">{{ item.nickname }}</div>
              <div class="phone">綁定手機號：{{ item.phone }}</div>
            </div>
          </div>
          <div
            class="currentBnt acea-row row-center-wrapper font-color-red"
            v-if="item.uid === userInfo.uid"
          ></div>
        </div>
      </div>
    </div>
    <div
      class="promote-router"
      v-if="userInfo.router && userInfo.router.length == 1"
    >
      <div class="title">推廣路線</div>
      <div class="container">
        <div
          class="router"
          v-for="(route, index) in userInfo.router"
          :key="index"
        >
          <div class="promoter">
            <div class="avatar">
              <img :src="route.avatar" />
            </div>
            <div class="info">
              <div class="nickname">暱稱：{{ route.nickname }}</div>
              <div class="id">ID：{{ route.uid }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="more-router"
      v-if="userInfo.router && userInfo.router.length > 1"
      @click="toPromoteRouter"
    >
      <div class="title">推廣路線</div>
      <div class="to-right"></div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>暱稱</div>
        <div class="input user-name">
          <input type="text" v-model="userInfo.nickname" />
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>ID號</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="userInfo.uid" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <!-- <div v-if="!userInfo.phone">
        <div class="item acea-row row-between-wrapper">
          <div>绑定手机号</div>
          <div class="input">
            暂未绑定手机号<span class="iconfont icon-xiangyou"></span>
          </div>
        </div>
      </div> 
      <div class="item acea-row row-between-wrapper" v-else-if="userInfo.phone">
        <div>手机号码</div>
        <div class="input acea-row row-between-wrapper">
          <div class="input acea-row row-between-wrapper">
            <input
              type="text"
              :value="userInfo.phone"
              disabled
              class="id"
            /><span class="iconfont icon-suozi"></span>
          </div>
        </div>
      </div>-->
    </div>
    <div class="form-box">
      <div class="title-doctor">填寫信息</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="真實姓名" prop="real_name">
          <el-input v-model="ruleForm.real_name"></el-input>
        </el-form-item>
        <el-form-item label="手機號碼" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item
          label="全一编号"
          prop="doctor_id"
          v-if="
            user.first_spread_uid == 1612 &&
              ruleForm.certification_type == '醫生'
          "
        >
          <el-input v-model="ruleForm.doctor_id"></el-input>
        </el-form-item>
        <el-form-item label="管理級別" prop="certification_type">
          <el-select v-model="ruleForm.certification_type">
            <el-option
              label="醫生"
              value="醫生"
              v-if="certification_type > 2"
            ></el-option>
            <el-option
              label="代表"
              value="代表"
              v-if="certification_type > 3"
            ></el-option>
            <el-option
              label="代理"
              value="代理"
              v-if="certification_type > 4"
            ></el-option>
            <el-option
              label="省代"
              value="省代"
              v-if="certification_type > 5"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="ruleForm.remark" type="textarea"></el-input>
        </el-form-item>
        <!-- <el-form-item label="學術研討費" prop="brokerage">
          <el-input v-model="ruleForm.brokerage"></el-input>
        </el-form-item> -->
        <el-form-item
          label="所屬醫院"
          prop="hospital"
          v-if="ruleForm.certification_type == '醫生'"
        >
          <el-input v-model="ruleForm.hospital"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属科室" prop="department">
          <DepartmentHospital
            @department-val="departmentName"
            :departmentVal="ruleForm.department"
            :departmentOptions="departmentOptions"
          ></DepartmentHospital>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="modifyBnt bg-color-red" @click="submit('ruleForm')">
      保存修改
    </div>
    <div class="modifyBnt bg-color-gray" @click="unbind()" v-if="showUnbind">
      解除綁定
    </div>
    <!-- Matomo Image Tracker-->
    <img
      src="https://piwik.sosyao.com/matomo.php?idsite=15&amp;rec=1"
      style="border:0"
      alt=""
    />
    <!-- End Matomo -->
    <!-- <el-dialog title="提示" visible="true" width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button>取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import axios from "axios";
import { VUE_APP_API_URL, isWeixin } from "@utils";
// import ThreeHospital from "@components/moblie/ThreeHospital.vue";
// import DepartmentHospital from "@components/moblie/DepartmentHospital.vue";
import {
  getNextUserInfo,
  userSpreadEdit,
  getUser,
  userUnbind,
  getUserInfo
} from "@api/user";

export default {
  name: "DoctorData",
  components: {
    // ThreeHospital,
    // DepartmentHospital
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      certification_type: "",
      avatar: "",
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0,
      userInfo: {},
      ruleForm: {
        real_name: "",
        phone: "",
        certification_type: "",
        brokerage: "",
        remark: "",
        doctor_id: ""
      },
      rules: {
        real_name: [
          { required: false, message: "請輸入名字", trigger: "blur" }
        ],
        // doctor_id: [{ required: true, message: "請輸入编号", trigger: "blur" }],
        phone: [
          { required: false, message: "請輸入手機號碼", trigger: "blur" },
          { min: 11, max: 11, message: "長度為11個數字", trigger: "blur" }
        ],
        certification_type: [
          { required: true, message: "請選擇分銷級別", trigger: "blur" }
        ],
        brokerage: [
          { required: true, message: "請輸入學術研討費", trigger: "blur" }
        ]
      },
      provinceVal: "",
      cityVal: "", //拼接医院的市
      hospitalOptions: [], // 医院数据
      departmentOptions: [], // 科室数据
      showUnbind: this.$route.query.grade == "0" ? true : false,
      user: {}
    };
  },
  watch: {
    $route(n) {
      if (n.name === "DoctorData") {
        this.$store.dispatch("USERINFO", true);
        this.getSpread();
      }
    }
  },
  created() {
    getUserInfo().then(res => {
      this.user = res.data;
    });
  },
  async mounted() {
    this.getSpread();

    const res = await axios.get("/hospital.json", {});
    this.$set(this, "hospitalOptions", res.data.hospital);
    this.$set(this, "departmentOptions", res.data.department);
    console.log("grade", this.$route.query.grade);
  },
  methods: {
    getSpread() {
      this.isWeixin = isWeixin();
      //生命周期里接收参数
      this.id = this.$route.query.id;
      this.certification_type = this.$route.query.certification_type;
      if (!this.id) {
        getUser().then(res => {
          let id = res.data.uid;
          //this.certification_type = res.data.certification_type;
          getNextUserInfo(id).then(res => {
            this.userInfo = res.data;
            this.ruleForm = res.data;
            //this.certification_type = res.data.certification_type;
            switch (this.ruleForm.certification_type) {
              case 0:
                this.ruleForm.certification_type = "无";
                break;
              case 1:
                this.ruleForm.certification_type = "患者";
                break;
              case 2:
                this.ruleForm.certification_type = "醫生";
                break;
              case 3:
                this.ruleForm.certification_type = "代表";
                break;
              case 4:
                this.ruleForm.certification_type = "代理";
                break;
              case 5:
                this.ruleForm.certification_type = "省代";
                break;
            }
            this.switchUserInfo.forEach((item, index) => {
              if (item.uid == res.data.uid) {
                this.switchUserInfo.splice(index, 1);
              }
            });
            this.switchUserInfo.splice(0, this.switchUserInfo.length);
            this.switchUserInfo.push(res.data);
          });
        });
      } else {
        // 接受参数关键代码;
        getNextUserInfo(this.id).then(res => {
          this.userInfo = res.data;
          this.ruleForm = res.data;
          //this.certification_type = this.ruleForm.certification_type;
          switch (this.ruleForm.certification_type) {
            case 0:
              this.ruleForm.certification_type = "无";
              break;
            case 1:
              this.ruleForm.certification_type = "患者";
              break;
            case 2:
              this.ruleForm.certification_type = "醫生";
              break;
            case 3:
              this.ruleForm.certification_type = "代表";
              break;
            case 4:
              this.ruleForm.certification_type = "代理";
              break;
            case 5:
              this.ruleForm.certification_type = "省代";
              break;
          }
          this.switchUserInfo.splice(0, this.switchUserInfo.length);
          this.switchUserInfo.push(res.data);
        });
      }
    },
    submit: function(ruleForm) {
      let that = this;
      console.log("spread");
      console.log(this.user.first_spread_uid);
      console.log(this.ruleForm.certification_type);
      if (
        this.user.first_spread_uid == 1612 &&
        this.ruleForm.certification_type == "醫生" &&
        !this.ruleForm.doctor_id
      ) {
        console.log("qunayi");
        return this.$dialog.toast({
          mes: "请输入全一编号"
        });
      }
      that.$refs[ruleForm].validate(valid => {
        if (valid) {
          let formData = {
            uid: that.id
          };
          Object.assign(formData, that.ruleForm);
          let newHospital =
            this.provinceVal + "/" + this.cityVal + "/" + formData.hospital;
          switch (formData["certification_type"]) {
            case "无":
              formData["certification_type"] = 0;
              break;
            case "患者":
              formData["certification_type"] = 1;
              break;
            case "醫生":
              formData["certification_type"] = 2;
              break;
            case "代表":
              formData["certification_type"] = 3;
              break;
            case "代理":
              formData["certification_type"] = 4;
              break;
            case "省代":
              formData["certification_type"] = 5;
              break;
          }
          formData["hospital"] = newHospital; //拼接医院省市
          userSpreadEdit(formData).then(res => {
            that.$dialog.toast({
              mes: res.msg
            });
            that.$router.push("/user/promoter_list");
          });
          // doctorEdit(formData).then(res => {
          //   if (res.msg == "修改成功") {
          //     that.$dialog.toast({
          //       mes: "修改成功"
          //     });
          //     this.roturBack();
          //   } else {
          //     that.$dialog.toast({
          //       mes: "修改失败请重新提交"
          //     });
          //   }
          // });
        } else {
          return false;
        }
      });
    },
    roturBack() {
      this.$router.go(-1);
    },
    // 子组件返回所选中的医院名称
    hospitalName(hospitalVal, cityVal, provinceVal) {
      this.provinceVal = provinceVal;
      this.cityVal = cityVal;
      this.ruleForm.hospital = hospitalVal;
    },
    // 子组件返回所选中的科室名称
    departmentName(val) {
      this.ruleForm.department = val;
    },
    unbind() {
      let that = this;
      // this.$dialog.confirm({
      //   title: "是否解除绑定？",
      //   showConfirmButton: true
      // });
      this.$dialog.confirm({
        mes: "是否解除綁定?",
        opts: [
          {
            txt: "是",
            color: "red",
            callback: () => {
              userUnbind(this.userInfo.uid)
                .then(res => {
                  that.$dialog.success(res.msg).then(() => {
                    that.$router.replace("/user/promoter_list");
                  });
                })
                .catch(err => {
                  this.$dialog.error(err.msg);
                });
            }
          },
          {
            txt: "否",
            color: false,
            callback: () => {
              that.$dialog.toast({
                mes: "已取消"
              });
            }
          }
        ]
      });
    },
    toPromoteRouter() {
      let type = 0;
      switch (this.ruleForm.certification_type) {
        case "无":
          type = 0;
          break;
        case "患者":
          type = 1;
          break;
        case "醫生":
          type = 2;
          break;
        case "代表":
          type = 3;
          break;
        case "代理":
          type = 4;
          break;
        case "省代":
          type = 5;
          break;
      }
      console.log(type);
      this.$router.push(
        `/user/promote_router?certification_type=${
          this.$route.query.grade
        }&uid=${this.userInfo.uid}`
      );
    }
  }
};
</script>
<style scoped>
.form-box {
  background: #fff;
  padding-right: 0.5rem;
  padding-bottom: 0.01rem;
}
.form-box .title-doctor {
  font-size: 16px;
  line-height: 1rem;
  font-weight: 700;
  margin-left: 0.3rem;
}
.el-form-item__label {
  font-size: 16px;
}
.el-input__inner {
  font-size: 16px;
}
.personal-data .list .item .input.user-name {
  width: 4.5rem;
}
.promote-router {
  background-color: #ffffff;
  margin: 0.1rem 0;
  padding: 0.3rem 0.3rem;
}
.promote-router .title {
  font-size: 0.32rem;
  margin-bottom: 0.1rem;
}
.promote-router .container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.promote-router .container .router {
  position: relative;
  display: flex;
  align-items: center;
}
.promote-router .container .router .promoter {
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
}
.promote-router .container .router .promoter .avatar {
  width: 0.96rem;
  height: 0.96rem;
  margin-right: 0.1rem;
}
.promote-router .container .router .promoter .avatar img {
  width: 100%;
  height: 100%;
}

.more-router {
  background-color: #ffffff;
  margin: 0.1rem 0;
  padding: 0.3rem 0.3rem;
  display: flex;
  align-items: center;
}
.more-router .title {
  font-size: 0.32rem;
  flex-grow: 1;
}
.more-router .to-right {
  width: 10px;
  height: 10px;
  border-right: 1px gray solid;
  border-bottom: 1px gray solid;
  transform: rotate(-45deg);
}
</style>
